export default __webpack_public_path__ + "static/media/new-header-logo.00fbdc17.png";